function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 51 51"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M2 30l7.38 19.38L15.85 30m28.61 0v19.38M50 30H38.92M20.46 49.38l1.85-4.84m12.92 4.84l-1.85-4.84m0 0L27.85 30 22.3 44.54m11.07 0H22.31M47.94 2.25l-17.42 17.5m1.86-12.5a3.12 3.12 0 100-6.24 3.12 3.12 0 000 6.24zM46.07 21a3.12 3.12 0 10-.01-6.24 3.12 3.12 0 00.01 6.24z"
}), /*#__PURE__*/React.createElement("rect", {
  width: "16",
  height: "20",
  x: "1",
  y: "1",
  stroke: "currentColor",
  strokeWidth: "2",
  rx: "8"
})));